// services/partners.js
import axiosInstance from './axiosInstance';

const PARTNERS_API_URL = '/partners';

const partnersService = {
  async get(idempresa) {
    try {
      const response = await axiosInstance.get(`${PARTNERS_API_URL}/get.php?idempresa=${idempresa}`);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error('Erro ao obter partners:', error);
      return [];
    }
  },

  async getById(idempresa, idpartner) {
    try {
      const response = await axiosInstance.get(`${PARTNERS_API_URL}/getById.php?idempresa=${idempresa}&idpartner=${idpartner}`);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error('Erro ao obter partner por ID:', error);
      return [];
    }
  },

  async set(partnerData) {
    try {
      const response = await axiosInstance.post(`${PARTNERS_API_URL}/set.php`, partnerData);
      return response.data;
    } catch (error) {
      console.error('Erro ao guardar partner:', error);
      throw error;
    }
  },

  async unset(idempresa, idpartner) {
    try {
      const response = await axiosInstance.get(`${PARTNERS_API_URL}/unset.php?idempresa=${idempresa}&idpartner=${idpartner}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao remover partner:', error);
      throw error;
    }
  },

  // Commissions methods - /api/partners/comissions
  async getCommissions(idempresa, idpartner) {
    try {
      const response = await axiosInstance.get(`${PARTNERS_API_URL}/comissions/get.php?idempresa=${idempresa}&idpartner=${idpartner}`);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error('Erro ao obter comissões:', error);
      return [];
    }
  },

  async setCommissions(commissionsData) {
    try {
      const response = await axiosInstance.post(`${PARTNERS_API_URL}/comissions/set.php`, commissionsData);
      return response.data;
    } catch (error) {
      console.error('Erro ao guardar comissões:', error);
      throw error;
    }
  },

  async getEmails(idempresa, idpartner) {
    try {
      const response = await axiosInstance.get(`${PARTNERS_API_URL}/comissions/getEmails.php?idempresa=${idempresa}&idpartner=${idpartner}`);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error('Erro ao obter emails:', error);
      return [];
    }
  },

  async sendEmail(idempresa, idpartner) {
    try {
      const response = await axiosInstance.get(`${PARTNERS_API_URL}/comissions/sendEmail.php?idempresa=${idempresa}&idpartner=${idpartner}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao enviar email:', error);
      throw error;
    }
  }
};

export default partnersService;
